import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-2 right-2 p-1 group hover:bg-gray-50 rounded-full flex items-center transition duration-300 ease-in-out" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-auto",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      disabled: _ctx.loading,
      type: "button",
      class: _normalizeClass(["text-gray-400 group-hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-300", _ctx.loading ? 'cursor-not-allowed' : '']),
      "aria-label": "Close"
    }, _hoisted_4, 10, _hoisted_2)
  ]))
}